import React, { useState } from 'react';
import './Shape.scss';

const shapeColours = [
  '#EEE80C',
  '#FF6AB8',
  '#02BBDC',
  '#3582DB',
  '#67CB29',
  '#00B778',
  '#02701F',
  '#FF7636',
  '#E99200',
];
const shapeNames = [
  'mountain',
  'petal',
  'arc',
  'rainbow',
  'leaf',
  'vessel',
  'flower',
  'pebbles',
  'circle',
  'muncher',
  'square',
  'moon',
];

const ShapeSvg = ({ shapeColourHex, shapeIndex }) => {
  switch (shapeIndex) {
    case (0):
      return (
        <svg viewBox="0 0 114 114" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M.482 113.465C4.11 92.02 6.684 77.074 8.206 68.623 15.415 28.593 35.71 6.425 44.72 2.676c8.74-3.638 18.428-3.19 28.075 5.744 9.801 9.075 21.54 27.235 27.632 49.848 8.06 29.915 12.554 48.314 13.48 55.197H.483z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (1):
      return (
        <svg viewBox="0 0 98 128" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M49.737.013C16.76 38.648.272 66.414.272 83.313c0 25.347 2.968 46.52 49.465 44.55 46.498-1.97 54.398-36.93 43.723-57.97-7.117-14.025-21.692-37.32-43.723-69.88z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (2):
      return (
        <svg viewBox="0 0 159 115" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M158.405 2.24c-10.262 1.086-18.007 1.629-23.238 1.629-5.23 0-10.44-.272-15.628-.814 1.514 18.288-.515 33.645-6.088 46.07-8.359 18.64-4.88 31.386-34.034 31.386s-27.005-9.8-32.396-17.785C41.63 54.741 35.325 40.95 33.432 21.595c-1.262-12.903-2.005-20-2.23-21.293H.815C-1.188 31.845.674 54.49 6.398 68.237c8.586 20.62 18.504 46.59 73.02 46.59 54.514 0 55.378-19.772 65.627-39.396 10.25-19.625 12.572-34.016 13.36-46.832.525-8.545.525-17.33 0-26.358z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (3):
      return (
        <svg viewBox="0 0 137 118" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.142 114.909H64.994V86.896c1.026-5.008 2.85-7.513 5.473-7.513 2.623 0 5.381.989 8.274 2.966l2.461 10.374v24.58h25.846l19.665-2.394h9.683c-1.303-41.201-2.757-64.228-4.363-69.082-2.41-7.28-11.658-39.916-45.873-44.217-34.216-4.3-46.17 3.382-46.17 3.382L21.275 16.523C12.189 27.805 6.895 34.701 5.395 37.21 3.141 40.974.774 47.882.774 54.808c0 6.926 2.367 23.056 2.367 32.088v28.013z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (4):
      return (
        <svg viewBox="0 0 131 119" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M.57 15.932V61.67c6.887 24.033 13.984 38.226 21.29 42.578 10.958 6.527 18.848 14.064 26.223 14.064h22.172c4.293 0 25.766-8.739 30.931-11.402 5.165-2.662 15.217-10.693 19.488-16.025 4.27-5.332 10.153-21.724 10.153-37.29 0-15.566.932-46.951-17.894-46.951-18.827 0-17.064 10.722-17.064 25.155 0 14.433 1.67 23.233 0 26.552-1.67 3.32-4.713 4.756-6.553 0-1.839-4.756-4.056-38.452-7.904-44.223C77.564 8.356 69.213.606 57.545 2.744c-11.668 2.137-9.462 12.903-9.462 20.979 0 8.076 5.034 39.242 2.517 42.812-2.517 3.57-5.356 2.76-5.356-1.714 0-4.475-2.219-36.82-5.413-45.061C36.637 11.517 34.015.818 18.964.818 8.93.818 2.799 5.856.57 15.932z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (5):
      return (
        <svg viewBox="0 0 119 128" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M-.008.827h119L96.778 40.622l22.214 23.4-22.214 23.82 22.214 39.985h-119l22.185-39.985-22.185-23.82 22.185-23.4z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (6):
      return (
        <svg viewBox="0 0 125 139" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M35.457 23.13C37.626 9.521 44.176 1.943 55.107.396 71.503-1.925 80.72 10.878 82.019 13.822c.866 1.963 1.648 4.595 2.347 7.894 15.297-5.34 26.276-3.23 32.937 6.332 6.661 9.563 5.55 20.627-3.335 33.193 8.958 11.7 12.141 23.292 9.548 34.773-2.592 11.482-12.733 17.66-30.423 18.538-5.678 15.71-14.067 23.565-25.165 23.565-11.099 0-20.268-7.855-27.508-23.565-15.79 2.919-26.534.36-32.23-7.674-5.696-8.034-4.683-18.61 3.038-31.728C.721 64.654-2.412 53.124 1.83 40.561 6.07 27.998 17.28 22.187 35.457 23.13z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (7):
      return (
        <svg viewBox="0 0 119 114" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M30.155 58.773C14.743 52.407 7.037 44.79 7.037 35.923 7.037 22.62 13.248.367 57.403.367c44.156 0 58.187 14.041 59.922 34.046 1.157 13.336-10.71 21.447-35.598 24.332 21.772 4.09 33.638 10.841 35.598 20.255 2.94 14.12.837 14.326 0 17.88-.838 3.552-10.972 16.984-54.387 16.984-43.416 0-56.52-5.469-61.712-22.2-5.19-16.73 10.408-24.149 16.085-26.788a951.37 951.37 0 0012.844-6.104z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (8):
      return (
        <svg viewBox="0 0 107 102" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.522 36.47l11.152-18.803C18.758 11.261 25.537 6.8 34.012 4.283 46.722.51 54.96-.996 69.97 4.283c4.126 1.452 8.016 2.512 11.669 3.18l8.173 3.409c9.331 8.379 14.563 15.793 15.696 22.243 1.698 9.674.599 35.923-14.314 50.235-14.913 14.312-25.795 14.584-40.337 17.99-14.543 3.406-31.959-10.429-40.616-22.006C2.305 68.72.401 61.988.14 56.664a28.799 28.799 0 01-.034-1.417c0-3.7.805-9.96 2.416-18.778z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (9):
      return (
        <svg viewBox="0 0 117 113" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M116.044 29.058C109.195 17.004 100.64 9.08 90.38 5.286 74.987-.404 47.099.783 42.1 1.826 37.102 2.869 10.355 11.231 2.44 38.82c-7.914 27.588 9.14 60.098 16.15 65.244 7.01 5.145 27.66 11.223 56.172 8.184 28.514-3.039 38.933-11.799 41.282-17.86 2.35-6.06.62-16.677-9.241-21.549-9.86-4.872-39.278-1.612-48.119-5.908-8.842-4.296-3.269-14.397 6.405-14.397 9.673 0 41.38.294 46.325-6.84 3.297-4.757 4.84-10.302 4.63-16.636z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (10):
      return (
        <svg viewBox="0 0 103 118" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M30.6.117C25.452 4.233 20.4 12.8 15.444 25.819 10.488 38.84 5.38 61.161.117 92.79L100.9 117.116l2.055-102.43L30.6.116z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    case (11):
      return (
        <svg viewBox="0 0 121 134" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M59.81 0c-3.148 32.507-1.542 55.587 4.82 69.24 9.543 20.478 21.394 31.126 35.121 38.89 9.152 5.176 16.15 9.053 20.992 11.63-22.73 8.635-39.721 13.33-50.971 14.086-16.876 1.134-45.428-3.537-60.444-29.745-15.016-26.207-13.29-63.245 15.417-82.635C43.884 8.54 55.572 1.384 59.81 0z"
            fill={shapeColourHex}
            fillRule="evenodd"
          />
        </svg>
      );
    default:
      return null;
  }
};

const Shape = ({ shapeColour = null, shapeName = null }) => {
  const [randColourIndex] = useState(Math.floor(Math.random() * shapeColours.length));
  const [randShapeIndex] = useState(Math.floor(Math.random() * shapeNames.length));
  const shapeColourHex = !shapeColour ? shapeColours[randColourIndex] : shapeColour;
  const shapeIndex = shapeName ? shapeNames.indexOf(shapeName.toLowerCase()) : randShapeIndex;
  return (
    <div className={`shape shape-${shapeNames[shapeIndex]}`}>
      <ShapeSvg
        shapeIndex={shapeIndex}
        shapeColourHex={shapeColourHex}
      />
    </div>
  );
};

export default Shape;
